if (__SHOULD_POLYFILL_REQUESTIDLECALLBACK__) {
  if (!window.requestIdleCallback) {
    /**
     * The polyfill can't report idle time, but the real API ceiling is a 50 ms, so we're using this value
     *
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/IdleDeadline/timeRemaining}
     * */
    const IDLE_DEADLINE_MS = 50 as const

    // polyfill (almost) for Safari
    // `timeout` only caps the wait for an idle period, so this shim runs right away
    window.requestIdleCallback = (callback: IdleRequestCallback): number =>
      window.setTimeout(() => {
        const start = Date.now()
        callback({
          didTimeout: false,
          timeRemaining: () => Math.max(0, IDLE_DEADLINE_MS - (Date.now() - start)),
        })
      })

    window.cancelIdleCallback = (handle: number) => clearTimeout(handle)
  }
}
